var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 76,
    viewBox: "0 0 78 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2808"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.5507 76C46.1753 76 53.6288 73.7713 59.9684 69.5958C66.308 65.4204 71.2491 59.4856 74.1669 52.542C77.0847 45.5984 77.8482 37.9579 76.3607 30.5866C74.8732 23.2153 71.2016 16.4444 65.8102 11.13C60.4188 5.81558 53.5497 2.1964 46.0716 0.730166C38.5935 -0.736071 30.8422 0.0164926 23.798 2.89262C16.7538 5.76875 10.733 10.6393 6.49696 16.8883C2.26096 23.1374 0 30.4843 0 38C0 48.0782 4.06158 57.7436 11.2912 64.87C18.5209 71.9964 28.3264 76 38.5507 76Z",
    fill: "url(#paint0_linear_458_348)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M55.8371 24.2324H21.2685C20.8865 24.2324 20.5201 24.3833 20.25 24.6518C19.9799 24.9203 19.8281 25.2845 19.8281 25.6643V50.0063C19.8281 50.7659 20.1316 51.4943 20.6719 52.0313C21.2121 52.5684 21.9448 52.8701 22.7088 52.8701H54.3967C55.1607 52.8701 55.8934 52.5684 56.4337 52.0313C56.9739 51.4943 57.2774 50.7659 57.2774 50.0063V25.6643C57.2774 25.2845 57.1257 24.9203 56.8555 24.6518C56.5854 24.3833 56.2191 24.2324 55.8371 24.2324ZM33.2793 38.5513L22.7088 48.1825V28.9201L33.2793 38.5513ZM35.411 40.4933L37.5715 42.471C37.8373 42.7135 38.1848 42.8481 38.5456 42.8481C38.9063 42.8481 39.2539 42.7135 39.5196 42.471L41.6801 40.4933L52.1227 50.0063H24.972L35.411 40.4933ZM43.8263 38.5513L54.3967 28.9183V48.1843L43.8263 38.5513Z",
    fill: "#F8FAFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_348",
    x1: -9.97585,
    y1: -8,
    x2: 94.4299,
    y2: 0.934219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF4EDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7547CD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.275954ad52f147ac0986b54b8156a74f.svg";
export { ForwardRef as ReactComponent };